import type { AxiosRequestConfig } from 'axios';
import { useLoginStore } from '@/features/login/store';
import { axiosWithToken } from '@/std/api/axios';
import { TooManyRequestsError } from './httpError';

/** @deprecated */
export function comTokenGet(url: string, config?: AxiosRequestConfig): Promise<any> {
    if (useLoginStore.getState().renovandoToken) {
        return Promise.resolve(null);
    }

    return axiosWithToken
        .get(url, config)
        .then((response) => {
            if (response) {
                return response;
            }
            return false;
        })
        .catch(getErrorResponse);
}

/** @deprecated */
export function comTokenPost(url: string, data?: any, config?: AxiosRequestConfig): Promise<any> {
    if (useLoginStore.getState().renovandoToken) {
        return Promise.resolve(null);
    }

    return axiosWithToken
        .post(url, data, config)
        .then((response) => {
            if (response) {
                return response;
            }
            return false;
        })
        .catch(getErrorResponse);
}

/** @deprecated */
export function comTokenPut(url: string, data?: any, config?: AxiosRequestConfig): any {
    if (useLoginStore.getState().renovandoToken) {
        return Promise.resolve(null);
    }

    return axiosWithToken
        .put(url, data, config)
        .then((response) => {
            if (response) {
                return response;
            }
            return false;
        })
        .catch(getErrorResponse);
}

/** @deprecated */
export function comTokenRemove(url: string, config?: AxiosRequestConfig): Promise<any> {
    if (useLoginStore.getState().renovandoToken) {
        return Promise.resolve(null);
    }

    return axiosWithToken
        .delete(url, config)
        .then((response) => {
            if (response) {
                return response;
            }
            return false;
        })
        .catch(getErrorResponse);
}

function getErrorResponse(error: unknown): unknown {
    if (error instanceof TooManyRequestsError) {
        return {
            data: {
                mensagem: error.message,
                registros: [{ mensagem: error.message, status: 'erro' }],
                status: 'erro',
            },
            status: 429,
        };
    }

    return (error as { response?: unknown }).response;
}
